import { render } from "./Token.vue?vue&type=template&id=4bf0f4a8&scoped=true"
import script from "./Token.vue?vue&type=script&lang=js"
export * from "./Token.vue?vue&type=script&lang=js"

import "./Token.vue?vue&type=style&index=0&id=4bf0f4a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf0f4a8"]])

export default __exports__